<template>
  <span>
    <a
      href="#"
      v-if="$store.state.user.scope.includes('puede-cambiar-prioridad-op')"
      @click.prevent="$bvModal.show(modalId)"
      ><i class="fa fa-lg fa-ship ml-1"></i
    ></a>
    <b-modal :id="modalId" title="Asignar embarque a pedido" @show="handleShow" @ok="handleOk" :ok-disabled="loading">
      <b-spinner v-if="loading"></b-spinner>
      <b-form-group label="Embarque" label-for="shipment">
        <b-form-select
          v-model="shipment"
          :options="shipmentOptions"
          value-field="id"
          text-field="boarding_number"
          id="shipment"
          :disabled="loading"
        ></b-form-select>
      </b-form-group>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "AssignShipment",
  data() {
    return {
      loading: false,
      ready: false,
      shipment: null,
      shipmentOptions: []
    };
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "Asignar envío"
    },
    data: {
      type: Object
    }
  },
  computed: {
    modalId() {
      return `modal-assign-shipment-${this.id}`;
    }
  },
  methods: {
    handleShow() {
      this.shipment = null;
      this.getShipments();
    },
    handleOk() {
      this.assignShipmentToOp(this.shipment);
    },
    async getShipments() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/comex/shipment/?limite=100&no_page&fields=id,boarding_number");
        this.shipmentOptions = response.data;
        // add null option
        this.shipmentOptions.unshift({ id: null, boarding_number: "Sin asignar" });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$$bvToast.toast("Error al obtener embarques", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
        this.ready = true;
      }
    },
    async assignShipmentToOp(shipmentId) {
      this.loading = true;
      try {
        await this.$axios.put(`/api/v1/purchase_order/${this.id}/assign_shipment/`, {
          shipment_id: shipmentId
        });
        this.$bvToast.toast("Embarque asignado correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true
        });
        this.$emit("refresh");
      } catch (error) {
        this.$bvToast.toast("Error al asignar embarque", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
